module.exports = require("@getvim/components-molecules-button-group");